<template>
  <section class="admin-content">
    <Navbar />
    <div class="admin-main">
      <div class="container">
        <div class="container">
          <div class="row list" style="margin-top: 50px">
            <div class="col-md-11" v-show="show">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="inputCity">Select Sector *</label>
                      <select class="form-control" v-model="sector">
                        <option value="Basic Healthcare Provision Fund">
                          Basic Healthcare Provision Fund
                        </option>

                        <option value="Voluntary Contributor">
                          Voluntary Contributor
                        </option>

                        <option value="State Civil Servant">
                          State Civil Servant
                        </option>

                        <option value="Universal Basic Education">
                          Universal Basic Education
                        </option>
                        <option value="LGA Civil Servant">
                          LGA Civil Servant
                        </option>
                        <option value="Oganized Private Sector Plan">
                          Organized Private Sector Plan
                        </option>
                        <option
                          value="Tertiary Student Health Insurance Plan (T-SHIP)"
                        >
                          Tertiary Student Health Insurance Plan (T-SHIP)
                        </option>
                      </select>
                    </div>

                    <div class="form-group col-md-6">
                      <label for="inputCity">LGA </label>
                      <select
                        class="form-control"
                        v-model="localgovt"
                        @change="fetchWards($event)"
                      >
                        <option
                          v-for="lga in lga_states"
                          v-bind:key="lga"
                          :value="lga"
                        >
                          {{ lga.local_name }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group col-md-6">
                      <label>Ward</label>
                      <select class="form-control" v-model="ward">
                        <option
                          v-for="ward in wards"
                          v-bind:key="ward.id"
                          :value="ward"
                        >
                          {{ ward.ward_name }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group col-md-6">
                      <label>Current Page: {{ current_page }} </label>
                      <input
                        type="text"
                        required
                        class="form-control"
                        v-model="current_page"
                        placeholder="Current Page"
                      />
                      <p class="text-primary">
                        currently showing data for Page {{ current_page }}
                      </p>
                    </div>

                    <div class="form-group col-md-6">
                      <label>Per Page: {{ per_page }} </label>
                      <input
                        type="text"
                        required
                        class="form-control"
                        v-model="per_page"
                        placeholder="Per Page"
                      />
                      <p class="text-primary">
                        How many Per Page do you want to display
                      </p>
                    </div>

                    <div class="form-group col-md-6">
                      <label for="inputCity">Image Uploaded From Date Onwards </label>
                      <input
                        type="date"
                        class="form-control"
                        v-model="user_image_updated_at"
                      />
                    </div>

                    <div class="form-group col-md-6">
                      <label for="inputCity">Start Date *</label>
                      <input
                        type="date"
                        class="form-control"
                        v-model="from"
                        @change="pushDate"
                      />
                    </div>

                    <div class="form-group col-md-6">
                      <label for="inputCity">End Date *</label>
                      <input
                        type="date"
                        class="form-control"
                        v-model="to"
                        @change="pushDate"
                      />
                    </div>

                    <div class="form-group col-md-12">
                      <label for="inputCity"
                        ><i class="fe fe-briefcase"></i> Select MDA
                      </label>
                      <!-- <select class="form-control" v-model="place_of_work">
                  <option
                    :value="mda.name"
                    v-for="mda in mdas"
                    v-bind:key="mda.id"
                  >
                    {{ mda.place_of_work }}
                  </option>
                </select> -->

                      <v-select
                        v-model="place_of_work"
                        :options="mdas"
                        required
                        label="place_of_work"
                      ></v-select>
                    </div>
                  </div>

                  <button
                    @click="filterEnrollees()"
                    class="btn btn-info btn-block btn-lg"
                    :disabled="disabled"
                    style="margin-top: 20px"
                  >
                    Filter
                  </button>
                  <br />
                  <div class="col-md-12" v-if="disabled == true">
                    <p class="text-primary">We are preparing your document</p>
                  </div>

                  <div v-show="showdownload">
                    <div v-if="results != ''">
                      <p class="h6">
                        {{ results.totals.total }} Enrollees In MDA
                      </p>
                      <p class="h6">
                        {{ results.principal.length }} Enrollees with picture
                        current page
                      </p>
                    </div>

                    <div class="row">
                      <button class="btn btn-info" @click="inspect = true">
                        preview data
                      </button>
                    </div>

                    <br />
                    <div class="col-md-12" style="margin-top: 20px">
                      <button
                        class="btn btn-info btn-block btn-lg"
                        @click="printMe"
                      >
                        Print to PDF
                      </button>
                    </div>
                    <div class="col-md-12">
                      <div class="card-header">
                        <p class="h3 text-center">
                          Enrollee Data for {{ sector }} in Page
                          {{ current_page }}
                        </p>
                      </div>
                    </div>

                    <div class="col-lg-12 col-md-12" v-show="inspect">
                      <div class="card m-b-30" id="printDiv">
                        <div class="card-body" v-if="results != ''">
                          <div
                            class="col-md-10 offset-md-1"
                            v-for="client in results.principal"
                            v-bind:key="client.id"
                          >
                            <div class="card" :style="backgrounder">
                              <div class="card-header">
                                <div class="row spacer-top">
                                  <div class="col-md-1">
                                    <span class="avatar avatar-xl">
                                      <img
                                        :src="sider"
                                        class="rounded-circle"
                                      />
                                    </span>
                                  </div>
                                  <div
                                    class="col-md-11 text-center text-primary"
                                  >
                                    <h2 class="h2">
                                      <strong
                                        >ZAMFARA STATE CONTRIBUTORY HEALTHCARE
                                        MANAGEMENT AGENCY</strong
                                      >
                                    </h2>
                                    <h2 class="h2">
                                      <strong>(ZAMCHEMA)</strong>
                                    </h2>
                                  </div>
                                </div>
                              </div>

                              <div class="card-body row">
                                <div
                                  class="col-md-4"
                                  v-if="
                                    client.picture_available ==
                                    'image_available'
                                  "
                                >
                                  <img
                                    :src="`https://claimify-api.hayokmedicare.ng/image/${client.user_image}`"
                                    class="img spacer-top"
                                    alt="User Photo"
                                    height="600"
                                    width="500"
                                    onerror="this.onerror=null; this.src='/assets/img/zamfara.jpg'"
                                  />
                                </div>

                                <div
                                  class="col-md-4"
                                  v-if="client.picture_available == null"
                                >
                                  <img
                                    :src="`https://zamchema.zm.gov.ng/${imageUrl}/${client.user_image}`"
                                    class="img spacer-top"
                                    alt="User Photo"
                                    height="600"
                                    width="500"
                                    onerror="this.onerror=null; this.src='/assets/img/zamfara.jpg'"
                                  />

                                  <!-- <img
                              :src="`https://zamchema.zm.gov.ng/portal-zamchema-zm-gov-ng/wp-content/uploads/gravity_forms/1-2b149b689a7c8a5cf9d81d8e19768f7d/2021/08/${client.user_image}`"
                              class="img spacer-top"
                              alt="User Photo"
                              height="600"
                              width="500"
                              onerror="this.onerror=null; this.src='/assets/img/zamfara.jpg'"
                            />
                     -->
                                </div>

                                <div class="col-md-8">
                                  <p class="h2 spacer-top-bottom">
                                    <strong class="text-primary"
                                      >SECTOR:</strong
                                    >
                                    <strong> {{ client.sector }}</strong>
                                  </p>
                                  <hr />
                                  <p class="h2 spacer-top-bottom">
                                    <strong class="text-primary">NAME :</strong>
                                    <strong>{{ client.firstname }}</strong
                                    >, {{ client.lastname }}
                                    {{ client.middlename }}
                                  </p>
                                  <hr />
                                  <p class="h2 spacer-top-bottom">
                                    <strong class="text-primary"
                                      >LGA/Ward:</strong
                                    >
                                    <strong
                                      ><span v-if="client.localgovt != null">{{
                                        client.localgovt.local_name
                                      }}</span
                                      >/<span v-if="client.ward != null">{{
                                        client.ward.ward_name
                                      }}</span>
                                    </strong>
                                  </p>
                                  <hr />
                                  <p class="h2 spacer-top-bottom">
                                    <strong class="text-primary"
                                      >ZAMCHEMA ID:</strong
                                    >
                                    <strong>
                                      {{ client.id_card_number }}
                                    </strong>
                                  </p>
                                  <hr />
                                  <p class="h2 spacer-top-bottom">
                                    <strong class="text-primary">
                                      FACILITY TO ACCESS CARE:
                                    </strong>
                                    <strong
                                      v-if="client.userprovider != null"
                                      >{{
                                        client.userprovider.agency_name
                                      }}</strong
                                    >
                                  </p>
                                  <hr />

                                  <p
                                    class="h2 spacer-top-bottom"
                                    v-if="client.place_of_work != null"
                                  >
                                    <strong class="text-primary">MDA:</strong>
                                    <strong> {{ client.place_of_work }}</strong>
                                  </p>
                                  <hr />
                                  <p class="h2 spacer-top-bottom">
                                    <strong
                                      class="text-primary"
                                      v-if="
                                        client.sector ==
                                        'Basic Healthcare Provision Fund'
                                      "
                                      >SPECIAL NEEDS:</strong
                                    >
                                    <strong>{{
                                      client.category_of_vulnerable_group
                                    }}</strong>
                                  </p>
                                 
                                </div>
                              </div>
                            </div>

                            <br />
                            <br />
                            <hr />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="vld-parent">
            <loading
              :active.sync="isLoading"
              loader="dots"
              :can-cancel="true"
              :is-full-page="fullPage"
            ></loading>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin
import Navbar from "@/views/Navbar.vue";

import { Client, Databases } from "appwrite";

const client = new Client();
const databases = new Databases(client);
databases;

client
  .setEndpoint("https://cloud.appwrite.io/v1")
  .setProject("649017a925e7eac07e22");

export default {
  components: {
    Loading,
    Navbar,
  },
  data() {
    return {
      loader: true,
      showdownload: false,
      inspect: false,
      user: null,
      sector: "",
      per_page: "50",
      ward: "",
      localgovt: "",
      place_of_work: "",
      edit: false,
      show: true,
      disabled: false,
      isLoading: false,
      fullPage: false,
      agency_id: "",
      provider_id: "",
      current_page: 1,
      mdas: [],
      state: "",
      category_of_vulnerable_group: "",
      lga_states: "",
      wards: [],
      from: "",
      to: new Date(),
      date: "",
      user_image_updated_at: "",
      results: [],
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.axios
      .get(`/api/v1/auth/lga/2683`)
      .then((response) => {
        this.lga_states = response.data.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },

  computed: {
    backgrounder() {
      let user_sector = this.sector;

      if (user_sector == "Basic Healthcare Provision Fund") {
        return "background-image: url('../assets/img/bhcpf_transparent.png'); background-size: cover; background-repeat: no-repeat;";
      } else {
        return "background-image: url('../assets/img/zamfara_transparent.png'); background-size: cover; background-repeat: no-repeat;";
      }
    },

    imageUrl() {
      let user_sector = this.sector;
      if (user_sector == "Basic Healthcare Provision Fund") {
        return "eportal-zamchema-zm-gov-ng/uploads/basic";
      } else {
        return "portal-zamchema-zm-gov-ng/wp-content/uploads/gravity_forms/1-2b149b689a7c8a5cf9d81d8e19768f7d";
      }
    },

    addOneDay() {
      var result = new Date(this.to);
      result.setDate(result.getDate() + 1);
      return result;
    },

    sider() {
      let user_sector = this.sector;

      if (user_sector == "Basic Healthcare Provision Fund") {
        return "/assets/img/zamfara_state.jpg";
      } else {
        return "https://zamchema.hayokinsurance.com/assets/img/zamfara.jpg";
      }
    },
  },

  methods: {
    filterEnrollees() {
      this.disabled = true;
      this.isLoading = true;
      this.axios
        .post(`/api/v1/auth/filterprintidcard?page=${this.current_page}`, {
          agency_id: "4",
          per_page: this.per_page,
          sector: this.sector,
          category_of_vulnerable_group: this.category_of_vulnerable_group,
          date: this.date,
          from: this.from,
          to: this.addOneDay,
          place_of_work: this.place_of_work.place_of_work,
          // lga_id: this.localgovt.id,
          ward: this.ward.id,
          user_image_updated_at: this.user_image_updated_at,
          with_picture: "with_picture",
        })
        .then((response) => {
          this.results = response.data;
          console.log(response);
          this.disabled = false;
          this.showdownload = true;
          this.isLoading = false;
          this.inspect = true;
          this.$toasted.success("Filtered Successfully", {
            position: "top-center",
            duration: 3000,
          });
        })
        .catch((error) => {
          this.disabled = false;
          this.isLoading = false;
          this.$toasted.error("Error!", {
            position: "top-center",
            duration: 3000,
          });

          console.error(error);
        });
    },

    fetchLga() {
      this.axios
        .get(`/api/v1/auth/lga/2683`)
        .then((response) => {
          this.lga_states = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    updateExp(client) {
      this.axios
        .post(`/api/v1/auth/dep/expiry`, {
          dep_id: client.id,
        })
        .then((response) => {
          this.lga_states = response.data.data;
          console.log(response);
          this.$toasted.success("updated Successfully", {
            position: "top-center",
            duration: 3000,
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    fetchWards() {
      this.axios
        .get(`/api/v1/auth/getwards/${this.localgovt.id}`)
        .then((response) => {
          this.wards = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    clearIt() {
      this.agency_id = "";
    },
    pushDate() {
      this.date = "date";
    },
    changeNumberID(client) {
      this.isLoading = true;
      this.axios
        .patch(`/api/v1/auth/id-card-number/change/${client.id}`)
        .then((response) => {
          console.log(response);
          this.$toasted.success("Changed Successfully", {
            position: "top-center",
            duration: 3000,
          });
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.error("Not Found!", {
            position: "top-center",
            duration: 3000,
          });
          this.isLoading = false;
        });
    },
    getMDAs() {
      this.axios
        .get(`/api/v1/auth/ministries/4`)
        .then((response) => {
          this.mdas = response.data.data;
          console.log(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    printMe() {
      var printContents = document.getElementById("printDiv").innerHTML;
      var originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
    },
  },
  created() {
    this.getMDAs();
  },
};
</script>

<style scoped>
.spacer-top {
  margin-top: 50px;
}
.spacer {
  margin-left: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
}
.spacer-top-bottom {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
